__turbopack_context__.v({
  "nav": "Nav-module__Ix43rG__nav",
});
